import CustomTable from '@myComponents/CustomTable';
import { ListNotifications } from '../../../graphql/Query/notifications';
import { DeleteNotification } from '../../../graphql/Mutation/notifications';
import { useMutation, useQuery } from '@apollo/client';
import { columns } from './columns';
import { useState } from 'react';
import Sidebar from './Sidebar';
import { handleConfirmCancel, handleError } from '@components/toast';

const currentDate = new Date();

const variables = {
  search: {
    membership: 'EMPTY',
    q: '',
    perPage: 10,
    page: 1
  }
};

const defaultValues = {
  title: '',
  membership: 'EMPTY',
  message: '',
  active: true,
  date: new Date(
    currentDate.getFullYear(),
    currentDate.getMonth(),
    currentDate.getDate(),
    currentDate.getHours(),
    0
  )
};

const Notifications = () => {
  const { data, refetch, loading } = useQuery(ListNotifications, {
    variables
  });
  const [valuesForm, setValuesForm] = useState({});
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [handleDisable] = useMutation(DeleteNotification);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    refetch();
  };

  const handleDelete = async (id) => {
    handleConfirmCancel('delete', false, async () => {
      try {
        await handleDisable({ variables: { id } });
        refetch();
      } catch (e) {
        handleError(e);
        throw e;
      }
    });
  };

  const handleUpdate = ({ e, row }) => {
    e.preventDefault();
    setValuesForm({
      ...row,
      date: new Date(row.date)
    });
    toggleSidebar();
  };

  return (
    <CustomTable
      loading={loading}
      store={data?.listNotifications?.docs || []}
      data={{ ...data?.listNotifications, docs: undefined }}
      refetch={refetch}
      headerOptions={{
        type: 'add',
        name: 'Crear Notification',
        handle: () => {
          setValuesForm(defaultValues);
          toggleSidebar();
        }
      }}
      filterOptions={{
        types: [
          {
            id: 'incomes_membership',
            name: 'membership',
            options: 'membershipOptions',
            type: 'select'
          }
        ]
      }}
      variables={variables}
      columns={columns({ handleDelete, handleUpdate })}
      sidebar={
        <Sidebar
          open={sidebarOpen}
          toggleSidebar={toggleSidebar}
          defaultValues={valuesForm}
        />
      }
    />
  );
};

export default Notifications;
